module.exports = __webpack_public_path__ + "img/Logo-Eagle.82324d0e.png";